(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.PocketPurchaseState=api;})(typeof window!=='undefined'?window:this,function(){
function createPurchaseState(storage){
 let brand=null,selection='',mode='mandatory',seen='',design='',order='';
 try{const saved=JSON.parse(storage?.getItem('pf.review.v2')||'null');if(saved){({brand,selection,mode,seen,design,order}=saved);}}catch(_){}
 const fingerprint=()=>JSON.stringify([brand,selection]);
 const designFingerprint=()=>{let data={};try{data=JSON.parse(selection)||{};}catch(_){}delete data.variant;return JSON.stringify([brand,data]);};
 const save=()=>{try{storage?.setItem('pf.review.v2',JSON.stringify({brand,selection,mode,seen,design,order}));}catch(_){}};
 return {
 setBrand(value,path){if(JSON.stringify(value)!==JSON.stringify(brand)||path&&path!==mode){brand=value;mode=path||'mandatory';seen=design=order='';save();}},
 setSelection(value){selection=JSON.stringify(value);save();},
 rendered(){if(brand&&mode==='early'){seen=fingerprint();save();}},
 reviewDesign(){if(brand){design=designFingerprint();save();}},
 reviewOrder(){if(brand&&design===designFingerprint()){order=fingerprint();save();}},
 ready(){return !!brand&&(mode==='early'?seen===fingerprint():design===designFingerprint()&&order===fingerprint());},
 fingerprint
 };}
return {createPurchaseState};
});
